$(function () {
    var cpJournalHeader = {
        $jsonFile: $('#cpJournalInfo').val(),
        $coden: '',
        init: function () {
            if ($('.cpJournalHeader__coden-input').length > 0) {
                cpJournalHeader.$coden = $('.cpJournalHeader__coden-input').val();
            }
            cpJournalHeader.ajax();
        },
        ajax: function () {
            var i;

            $.getJSON(cpJournalHeader.$jsonFile).done(function (jdata) {
                var editors = jdata.journalInfo.journal[cpJournalHeader.$coden].eic;
                var editorNames = $('div.cpJournalHeader__editorNames');
                editorNames.append(
                    '<span><a href="/page/' +
                        cpJournalHeader.$coden +
                        '/profile.html" title="About the Editor">' +
                        editors[0] +
                        '</a></span>'
                );
                if (editors.length > 1) {
                    $('div.cpJournalHeader__editorLabel').text('Editors-in-Chief');
                    $('div.cpJournalHeader__editorsLink a').text('Editors & Editorial Board');
                    for (i = 1; i < editors.length; i++) {
                        editorNames.append(
                            ', <span><a href="/page/' +
                                cpJournalHeader.$coden +
                                '/profile' +
                                i +
                                '.html" title="About the Editor">' +
                                editors[i] +
                                '</a></span>'
                        );
                    }
                }
                scrollToHash();
            });
        },
    };
    UX.cpJournalHeader = cpJournalHeader; // add to global namespace
});
